<template>
	<div style='width: 100%;'>
		<div class=" px-4 py-4 mb-4">
			<!-- text -->
			<div
				v-if='agendaEvent.events_agenda_text'
				class="agenda-card-description mb-3">
				{{ agendaEvent.events_agenda_text }}
			</div>

			<!-- date time -->
			<div
				v-if='agendaEvent.events_agenda_from && agendaEvent.events_agenda_to'
				class="agenda-card-date mb-3">
				{{ formatDateRange(agendaEvent.events_agenda_from, agendaEvent.events_agenda_to) }}
			</div>

			<!-- description -->
			<div
				class="agenda-card-description mb-3"
				v-if='agendaEvent.session_description'
				v-html='agendaEvent.session_description'
			></div>

			<!-- location -->
			<div class="agenda-card-location mb-3" v-if="agendaEvent.session_location">
				<v-icon x-small> mdi-map-marker</v-icon>
				{{ agendaEvent.session_location }}
			</div>

			<!-- tracks -->
			<div class='mb-3' v-if='agendaEvent.tracks.length > 0'>
				<div
					v-for="{ track_color, track_id, track_name } in agendaEvent.tracks"
					:key="track_id"
					class="agenda-card-tag mb-1"
					:style="`color: ${track_color}`"
				>
					<v-icon :color="track_color" dark small class="mr-1"> mdi-circle</v-icon>
					{{ track_name }}
				</div>
			</div>

			<!-- sponsored by -->
			<div
				class="agenda-card-description mb-3"
				v-if='agendaEvent.sponsored_by'
			>
				<strong>Sponsored By</strong> : {{ agendaEvent.sponsored_by }}
			</div>

			<!-- speakers -->
			<v-divider v-if='agendaEvent.speakers.length > 0' class="my-6"></v-divider>

			<h4
				v-if='agendaEvent.speakers.length > 0'
				class='mb-3'
			>Speaker(s)</h4>

			<div v-if='agendaEvent.speakers.length > 0'>
				<router-link
					:to="{
						name: 'speaker-by-id',
						params: {
							id: +speaker_id
						}
					}"
					v-for="{ speaker_logo, speaker_name, speaker_title, speaker_id } in agendaEvent.speakers.slice(0,3)"
					:key="speaker_id"
					class="attend-card-wrapper text-decoration-none d-flex align-center px-8 py-6 mb-4"
				>
					<Avatar
						class="mr-8 post-preview-card__avatar"
						ize="85"
						:avatar="speaker_logo"
					/>
					<div>
						<div
							v-if='speaker_name'
							class="attend-card-tittle mb-2"
						>
							{{ speaker_name }}
						</div>
						<div
							v-if='speaker_title'
							class="attend-card-location mb-2"
						>
							{{ speaker_title }}
						</div>
					</div>
				</router-link>
			</div>

			<div class='post-preview-card__link mt-3 text-center' v-if='agendaEvent.speakers.length >= 3'>
				<router-link
					:to="{
						name: 'event-session-speakers',
						params: {
							eventId: agendaEvent.events_id,
							sessionId: agendaEvent.events_agenda_id
						}
					}"
					class='d-flex text-decoration-none text-center align-center'
				>
					<span class='ma-auto'>Show All</span>
				</router-link>
			</div>

			<v-divider v-if='agendaEvent.uploads.length > 0' class="my-8"></v-divider>

			<!-- files -->
			<h4 class='mb-3' v-if='agendaEvent.uploads.length > 0'>File(s)</h4>

			<div v-if="agendaEvent.uploads && agendaEvent.uploads.length" class="mt-5">
				<div
					class="d-flex flex-column flex-wrap w-full pb-4 mb-n2"
					v-for="attachment in agendaEvent.uploads.slice(0,3)"
					:key="attachment.upload_id"
				>
					<SessionAttachments :attachment="attachment" />
				</div>
			</div>

			<div class='post-preview-card__link mt-3 text-center' v-if='agendaEvent.uploads.length >= 3'>
				<router-link
					:to="{
						name: 'event-session-files',
						params: {
							eventId: this.$route.params.eventId,
							sessionId: this.$route.params.sessionId
						}
					}"
					class="text-decoration-none"
				>
					<span>Show All</span>
				</router-link>
			</div>

			<v-divider v-if="agendaEvent.session_qa_is_available" class="my-8"></v-divider>

			<!-- questions -->
			<div v-if="agendaEvent.session_qa_is_available">
				<h4 class='mb-3'>Top 3 Session Question(s)</h4>
				<div v-if="agendaEvent.session_question_answers.length">
					<div 
						v-for="question in agendaEvent.session_question_answers" 
						:key="question.session_question_answer_id"
						class="attend-card-wrapper text-decoration-none d-flex align-center justify-space-between px-8 py-6 mb-4"
					>
						<span class="agenda-card__question text-truncate mr-2">
							{{ question.session_question_answer_text }}
						</span>
						<span class="agenda-card__question-count d-flex align-center">
							<v-icon small class="mr-1">
								mdi-thumb-up
							</v-icon>
							{{ question.session_question_count }}
						</span>
					</div>
				</div>
				<div class="d-flex justify-center">
					<router-link 
						:to="{name: 'event-session-questions'}" 
					>
						<v-btn v-if="!agendaEvent.session_question_answers.length" class="agenda-card__add-question-btn elevation-0">
							Add Question
						</v-btn>
						<v-btn v-else class="agenda-card__add-question-btn-view elevation-0">
							View More/Add
						</v-btn>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'
import SessionAttachments from '@/components/Resource/SessionAttachments.vue'

Vue.use(VueScrollTo)

export default {
	name: 'SessionCard',
	components: { 
		SessionAttachments, 
		Avatar
	},
	props: {
		agendaEvent: {
			type: Object,
			default: () => {},
		},
	},

	methods: {
		formatDateRange(dateFrom, dateTo) {
			const options = {
				weekday: 'long',
				hour: '2-digit',
				minute: '2-digit',
				hour12: true,
			}

			//Convert Unix timestamps to JavaScript Date objects
			const fromDate = new Date(dateFrom * 1000)
			const toDate = new Date(dateTo * 1000)

			// Format the dates
			const formattedFromDate = fromDate.toLocaleString('en-US', options)
			const formattedToDate = toDate.toLocaleTimeString('en-US', options)

			// Construct the formatted date range string
			return `${formattedFromDate} - ${formattedToDate}`
		},
	}
}
</script>

<style lang="scss">
.agenda-card {
	&-date {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
	}

	&-tag {
		color: rgb(106, 167, 80);
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&-location {
		display: flex;
		color: rgb(153, 153, 153);
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		line-height: 17px;

		i {
			color: rgb(153, 153, 153) !important;
		}
	}

	&__add-question-btn, &__add-question-btn-view {
		background: var(--button-main-background-color) !important;
		color: var(--button-main-color) !important;
		text-transform: capitalize;
		font-size: 16px !important;
		font-weight: 700;
		font-family: Montserrat, sans-serif;
	}

	&__add-question-btn-view {
		color: var(--button-main-background-color) !important;
		background: transparent !important;
	}

	&__question {
		font-size: 14px;
		font-weight: 700;
		font-family: Montserrat, sans-serif;
		color: var(--accent-color);
	}

	&-count {
        font-size: 14px;
        font-weight: 700;
        font-family: Montserrat, sans-serif;
        color: var(--accent-color);

		.v-icon {
            color: #42a0d8;
        }
    }
}
</style>
